import { DietCategoriesEnum, LitersPerDayEnum } from "../../Types/Enums/DietCategoriesEnum";

export const DIET_CATEGORIES_MAP = [
  { id: DietCategoriesEnum.NONE, labels: { 0: "ninguna", 1: "none" } },
  { id: DietCategoriesEnum.VEGETARIAN, labels: { 0: "vegetariana", 1: "vegetarian" } },
  { id: DietCategoriesEnum.VEGAN, labels: { 0: "vegana", 1: "vegan" } },
  { id: DietCategoriesEnum.KETO, labels: { 0: "keto", 1: "keto" } },
  { id: DietCategoriesEnum.LOW_CARB, labels: { 0: "bajo en carbohidratos", 1: "low carb" } },
  { id: DietCategoriesEnum.HYPO_CALORIC, labels: { 0: "hipocalórico", 1: "hypocaloric" } },
  { id: DietCategoriesEnum.HYPER_CALORIC, labels: { 0: "hipercalórico", 1: "hypercaloric" } },
  { id: DietCategoriesEnum.LOW_GLYCEMIC, labels: { 0: "diabética/bajo índice glucémico", 1: "diabetic/low glycemic" } },
];

export const LITERS_PER_DAY_MAP = [
  { id: LitersPerDayEnum.ONE_OR_LESS, labels: { 0: "uno o menos", 1: "one or less" } },
  { id: LitersPerDayEnum.AROUND_TWO, labels: { 0: "alrededor de dos", 1: "around two" } },
  { id: LitersPerDayEnum.THREE_OR_MORE, labels: { 0: "tres o más", 1: "three or more" } },
];
